import {Record, Map} from "immutable";

enum Type {
    Demand,
    Target,
    TraineeDemand,
    TraineeTarget,
}

const typeStringToEnum = {
    "demand": Type.Demand,
    "target": Type.Target,
    "trainee_target": Type.TraineeTarget,
    "trainee_demand": Type.TraineeDemand,
}

interface Properties {
    id: number
    type: Type
    demand: number
    year: number
}

export class Year extends Record({
    id: undefined,
    type: undefined,
    demand: undefined,
    year: undefined,
}) implements Properties {
    id: number
    type: Type
    demand: number
    year: number

    constructor(values: Properties) {
        super(values)
    }

    isDemand  = () => this.type === Type.Demand
    isTarget  = () => this.type === Type.Target
    isTraineeDemand = () => this.type === Type.TraineeDemand
}

export type JsonData =  {
    id: number
    type: "demand" | "target" | "trainee_demand"
    demand: number
    year: string
}

export const fromJs = ({
    id,
    type,
    demand,
    year,
}: JsonData): Year => new Year({
    id,
    type: typeStringToEnum[type],
    demand,
    year: parseInt(year),
})

export type Years = Map<number, Year>